// Licensed from NativeLabs, an LR Ventures LLC FZ platform.
import { UNAUTHORIZED } from "constants/auth.constants";
import * as constants from "constants/files.constants";
import { combineReducers } from "redux";

const initialList = {
  loading: false,
  error: false,
  ready: false,
  path: "",
  folders: [],
  files: [],
  tree: [],
  totals: {
    count: 0,
    size: 0,
  },
  quota: {
    max_storage: null,
    max_file_size: null,
  },
  trashCount: 0,
};

const listReducer = (state = initialList, action) => {
  switch (action.type) {
    case constants.SET_PATH:
      return {
        ...state,
        path: action.data || "",
      };
    case constants.FILES.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case constants.FILES.FAILURE:
      return {
        ...state,
        folders: [],
        files: [],
        loading: false,
        error: true,
        ready: false,
      };
    case constants.FILES.SUCCESS: {
      const {
        path,
        folders,
        files,
        tree,
        totals,
        quota,
        trash_count: trashCount,
      } = action.data;

      return {
        ...state,
        path: path || "",
        folders: folders || [],
        files: files || [],
        tree: tree || [],
        totals: totals || initialList.totals,
        quota: quota || initialList.quota,
        trashCount: trashCount || 0,
        loading: false,
        error: false,
        ready: true,
      };
    }
    case UNAUTHORIZED:
      return initialList;
    default:
      return state;
  }
};

const initialTrash = {
  loading: false,
  error: false,
  files: [],
  folders: [],
};

const trashReducer = (state = initialTrash, action) => {
  switch (action.type) {
    case constants.TRASH.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case constants.TRASH.FAILURE:
      return {
        ...state,
        files: [],
        folders: [],
        loading: false,
        error: true,
      };
    case constants.TRASH.SUCCESS: {
      const { files, folders } = action.data;

      return {
        ...state,
        files: files || [],
        folders: folders || [],
        loading: false,
        error: false,
      };
    }
    case UNAUTHORIZED:
      return initialTrash;
    default:
      return state;
  }
};

const initialSearch = {
  loading: false,
  error: false,
  query: "",
  files: [],
  folders: [],
};

const searchReducer = (state = initialSearch, action) => {
  switch (action.type) {
    case constants.SEARCH.REQUEST:
      return {
        ...state,
        query: action.data,
        loading: true,
      };
    case constants.SEARCH.FAILURE:
      return {
        ...state,
        files: [],
        folders: [],
        loading: false,
        error: true,
      };
    case constants.SEARCH.SUCCESS: {
      const { files, folders } = action.data;

      return {
        ...state,
        files: files || [],
        folders: folders || [],
        loading: false,
        error: false,
      };
    }
    case constants.SEARCH_RESET:
      return initialSearch;
    case UNAUTHORIZED:
      return initialSearch;
    default:
      return state;
  }
};

export default combineReducers({
  list: listReducer,
  trash: trashReducer,
  search: searchReducer,
});
